import EditablePropsType from '../../../types/composer';

export const textSchema = {
  type: EditablePropsType.RichText,
  label: 'Text',
  name: 'text',
};

export default textSchema;
